/**
 * 登录后回跳地址（localStorage.redirect_url）的写入规则（#879）
 *
 * 同源的各模块（订单管理、客户门户…）未登录时会把自己的整条地址写进 redirect_url 再跳网站登录页，
 * 网站登录后在 AuthPanel 读它、删掉、跳回。网站自己在会话过期时也写它。
 *
 * 规则：当前页若只是 ServiceCool 自己的默认落点（首页 / 登录页），而已有一个非默认落点的回跳地址，
 * 就保留已有的——否则失效令牌的那一档会先被守卫送到首页、刷新失败，再用首页冲掉模块的地址。
 * 其余情况照旧覆盖为当前页（在真实页面上过期，当前页就是更新的意图）。
 */

export const REDIRECT_URL_KEY = 'redirect_url';

// 网站 basename 为 /f/website（见 index.tsx / package.json homepage）
const DEFAULT_LANDING_PATHS = ['/f/website', '/f/website/home', '/f/website/home/auth', '/f/website/login'];

export const isDefaultLanding = (url: string): boolean => {
    if (!url) {
        return false;
    }
    try {
        const pathname = new URL(url, window.location.origin).pathname.replace(/\/+$/, '');
        return DEFAULT_LANDING_PATHS.includes(pathname);
    } catch (e) {
        return false;
    }
};

export const saveRedirectUrl = (url: string = window.location.href): void => {
    if (isDefaultLanding(url)) {
        const existing = localStorage.getItem(REDIRECT_URL_KEY) || '';
        if (existing && !isDefaultLanding(existing)) {
            return;
        }
    }
    localStorage.setItem(REDIRECT_URL_KEY, url);
};
